<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Update Food Court</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Update Food Court</h2>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h5 class="font-weight-medium mb-3 mb-md-4">Location: {{displayPark}}</h5>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
        <!-- ROOT CAUSE FIX: Removed ngb-panel + ng-template ngbPanelContent to prevent blank page issues -->
        <ngb-accordion [activeIds]="activeIds" class="form_accordion">
            <!-- Food Court Name Section -->
            <div class="mb-4 mb-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Food Court Name</h5>
                <div class="row row-gap-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" formControlName="FoodCourtName" id="name" class="form-control"
                                    placeholder="Food Court Name" [(ngModel)]=foodcourt.FoodCourtName>
                                <label>Food Court Name</label>
                            </div>
                            <div *ngIf="myForm.get('FoodCourtName').invalid && myForm.get('FoodCourtName').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('FoodCourtName').errors?.required">Food Court Name is required</div>
                                <div *ngIf="myForm.get('FoodCourtName').errors?.maxlength">The Food Court Name may not be
                                    longer
                                    than 100
                                    charecters</div>
                            </div>
                        </div>
                    </div>
            </div>
        </ngb-accordion>
        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button" (click)="goToListPage()">Cancel</button>
            <button class="btn btn-primary" type="submit">Update</button>
        </div>
    </form>
    <!-- form end -->
</div>